if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.isGridCard = this.dataset.gridCart === 'true';
        this.stepper = this.querySelector('.pcard-qa__stepper');
        this.qtyValue = this.querySelector('[data-qty-value]');
        this.plusBtn = this.querySelector('[data-qty-plus]');
        this.minusBtn = this.querySelector('[data-qty-minus]');
        if (this.isGridCard) {
          this.plusBtn?.addEventListener('click', () => this.changeQty(1));
          this.minusBtn?.addEventListener('click', () => this.changeQty(-1));
        }

        if (this.isGridCard) {
          this.restoreGridQty();
        }

        if (this.dataset.gridCart === 'true') {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            (event) => {
              if (event.source === 'product-form') return;
              this.updateGridItem(event);
            }
          );
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      async changeQty(change) {
        if (this.stepper.classList.contains('is-loading')) return;
        const previousQty = Number(this.qtyValue.textContent);
        const nextQty = previousQty + change;
        this.qtyValue.textContent = nextQty;
        this.stepper.classList.add('is-loading');
        this.stepper.querySelector('.loading__spinner').classList.remove('hidden');

        try {
          const variantId = this.form.querySelector('[name=id]').value;
          const cart = await fetch('/cart.js').then((r) => r.json());
          const item = cart.items.find((item) => item.variant_id == variantId);
          if (!item) return;

          const qty = item.quantity + change;
          
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: item.key,
              quantity: qty,
              sections: this.cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            }),
          });

          const data = await response.json();

          if (!response.ok || data.status || data.errors) {
            this.qtyValue.textContent = previousQty;
            alert(data.description || data.message || 'Something went wrong.');
            this.stepper.classList.remove('is-loading');
            this.stepper.querySelector('.loading__spinner').classList.add('hidden');

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-grid',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });

            return;
          }

          this.cart.renderContents(data, false);

          if (qty <= 0) {
            this.stepper.classList.add('hidden');
            this.submitButton.classList.remove('hidden');
          } else {
            this.qtyValue.textContent = qty;
          }
        } catch (e) {
          console.error(e);
          this.qtyValue.textContent = previousQty;
        } finally {
          this.stepper.classList.remove('is-loading');
          this.stepper.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      async restoreGridQty() {
        const variantId = Number(this.form.querySelector('[name=id]').value);
        const cart = await fetch('/cart.js').then(r => r.json());
        const item = cart.items.find(i => i.variant_id === variantId);
        if (!item) return;

        this.submitButton.classList.add('hidden');
        this.stepper.classList.remove('hidden');
        this.qtyValue.textContent = item.quantity;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            
            const quickAddModal = this.closest('quick-add-modal');
            if (this.isGridCard) {
              this.cart.renderContents(response, false);
              this.submitButton.classList.add('hidden');
              this.stepper.classList.remove('hidden');
              this.qtyValue.textContent = 1;
            } else if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      updateGridItem(event) {
        const currentVariantId = Number(this.form.querySelector('[name="id"]').value);
        const cartItems = Array.isArray(event.cartData?.items) ? event.cartData.items : [];
        const item = cartItems.find((i) => i.variant_id === currentVariantId);

        if (item) {
          this.submitButton.classList.add('hidden');
          this.stepper.classList.remove('hidden');
          this.qtyValue.textContent = item.quantity;
        } else {
          this.stepper.classList.add('hidden');
          this.submitButton.classList.remove('hidden');
          this.qtyValue.textContent = 1;
        }
      }
    }
  );
}
if (!customElements.get('discount-code')) {
  class DiscountCodeBar extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const discountField = this.querySelector('.discount-field__input');
      const copyButton = this.querySelector('.button-copy__discount');
      const primaryLabel = copyButton.dataset.primaryLabel;
      const secondaryLabel = copyButton.dataset.secondaryLabel;
      
      copyButton.addEventListener('click', () => {
        discountField.select();
        console.log(secondaryLabel)
        discountField.setSelectionRange(0, 99999);
        document.execCommand('copy');
        discountField.setSelectionRange(0, 0);
        copyButton.textContent = secondaryLabel;
        setTimeout(() => {
          copyButton.textContent = primaryLabel;
        }, 2000);
      });
    }
  }
  customElements.define('discount-code', DiscountCodeBar);
}
